<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Ferias',
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Ferias.vue